import React from 'react'
import styles from './CanvasControls.module.css'

const CanvasControls = ({ 
  onClear, 
  onSave, 
  onComplete,
  onUndo, 
  onRedo, 
  canUndo, 
  canRedo,
  isFreeDrawing = false
}) => {
  return (
    <div className={styles.controls}>

      {/* 되돌리기(앞으로가기) 버튼 */}
      <div className={styles.historyButtons}>
        <button 
          className={`${styles.historyBtn} ${!canUndo ? styles.disabled : ''}`}
          onClick={onUndo}
          disabled={!canUndo}
          title="실행취소 (Ctrl+Z)"
        >
          <i className="fas fa-undo"></i>
        </button>
        
        <button 
          className={`${styles.historyBtn} ${!canRedo ? styles.disabled : ''}`}
          onClick={onRedo}
          disabled={!canRedo}
          title="다시실행 (Ctrl+Y)"
        >
          <i className="fas fa-redo"></i>
        </button>
      </div>


      {/* 엑티브 버튼 */}
      <div className={styles.actionButtons}>
        <button 
          className={styles.deleteBtn}
          onClick={onClear}
          title="캔버스 전체 삭제"
        >
          <i className="fas fa-trash-alt"></i>
          삭제
        </button>
        
        <button 
          className={styles.saveBtn}
          onClick={onSave}
          title="그림 저장하기"
        >
          <i className="fas fa-save"></i>
          저장
        </button>
        
        {!isFreeDrawing && (
          <button 
            className={styles.completeBtn}
            onClick={onComplete}
            title="그리기 완료"
          >
            <i className="fas fa-check"></i>
            완료
          </button>
        )}
      </div>
      
    </div>
  )
}

export default CanvasControls